export class Sign {
    constructor(
        id?: string,
        idGarage?: string,
        codiceInsegna?: string,
        codiceGrafica?: string,
        personalizzazioni?: string,
        tipo?: string,
        targaEsposta?: boolean,
        targaPosizione?: string,
        note?: string,
        quantita?: number,
        stato?: number,
        descrizioneStato?: string,
        cssStato?: string,
        indirizzoConsegna?: string,
        localitaConsegna?: string,
        provinciaConsegna?: string,
        capConsegna?: string,
        indirizzoEsposizione?: string,
        localitaEsposizione?: string,
        provinciaEsposizione?: string,
        capEsposizione?: string,
        dataRilevazioneEsposizione?: Date,
        motivazioneEsposizione?: string,
        alternativaEsposizione?: string,
        dataRichiesta?: Date,
        dataConsegna?: Date,
        dataInsT0X?: Date,
        dataRimozioneT0X?: Date,
        dataRevoca?: Date,
        dataLetteraRimozione?: Date,
        dataLetteraRimozione2?: Date,
        dataRimozione?: Date,
        dataDanneggiamento?: Date,
        ubicazioneRimozione?: string,
        isEditable?: boolean,
        isDeliverable?: boolean,
        isDamageable?: boolean,
        isRemovable?: boolean,
        isScrapped?: boolean,
      ) {
        this.id = id;
        this.idGarage = idGarage;
        this.codiceInsegna = codiceInsegna;
        this.codiceGrafica = codiceGrafica;
        this.personalizzazioni = personalizzazioni;
        this.tipo = tipo;
        this.targaEsposta = targaEsposta;
        this.targaPosizione = targaPosizione;
        this.note = note;
        this.quantita = quantita;
        this.stato = stato;
        this.descrizioneStato = descrizioneStato;
        this.cssStato = cssStato;
        this.indirizzoConsegna = indirizzoConsegna;
        this.localitaConsegna = localitaConsegna;
        this.provinciaConsegna = provinciaConsegna;
        this.capConsegna = capConsegna;
        this.indirizzoEsposizione = indirizzoEsposizione;
        this.localitaEsposizione = localitaEsposizione;
        this.provinciaEsposizione = provinciaEsposizione;
        this.capEsposizione = capEsposizione;
        this.dataRilevazioneEsposizione = dataRilevazioneEsposizione;
        this.motivazioneEsposizione = motivazioneEsposizione;
        this.alternativaEsposizione = alternativaEsposizione;
        this.dataRichiesta = dataRichiesta;
        this.dataConsegna = dataConsegna;
        this.dataInsT0X = dataInsT0X;
        this.dataRimozioneT0X = dataRimozioneT0X;
        this.dataRevoca = dataRevoca;
        this.dataLetteraRimozione = dataLetteraRimozione;
        this.dataLetteraRimozione2 = dataLetteraRimozione2;
        this.dataRimozione = dataRimozione;
        this.dataDanneggiamento = dataDanneggiamento;
        this.ubicazioneRimozione = ubicazioneRimozione;
        this.isEditable = isEditable;
        this.isDeliverable = isDeliverable;
        this.isDamageable = isDamageable;
        this.isScrapped = isScrapped;
        this.isRemovable = isRemovable;
      }

    public id: string;
    public idGarage: string;
    public codiceInsegna: string;
    public codiceGrafica: string;
    public personalizzazioni: string;
    public tipo: string;
    public targaEsposta: boolean;
    public targaPosizione: string;
    public note: string;
    public quantita: number;
    public stato: number;
    public descrizioneStato: string;
    public cssStato: string;
    public indirizzoConsegna: string;
    public localitaConsegna: string;
    public provinciaConsegna: string;
    public capConsegna: string;
    public indirizzoEsposizione: string;
    public localitaEsposizione: string;
    public provinciaEsposizione: string;
    public capEsposizione: string;
    public dataRilevazioneEsposizione: Date;
    public motivazioneEsposizione: string;
    public alternativaEsposizione: string;
    public dataRichiesta: Date;
    public dataConsegna: Date;
    public dataInsT0X: Date;
    public dataRimozioneT0X: Date;
    public dataRevoca: Date;
    public dataLetteraRimozione: Date;
    public dataLetteraRimozione2: Date;
    public dataRimozione: Date;
    public dataDanneggiamento: Date;
    public ubicazioneRimozione: string;
    public isEditable: boolean;
    public isDeliverable: boolean;
    public isDamageable: boolean;
    public isRemovable: boolean;
    public isScrapped: boolean;
}